import {
  Box, Flex, Grid, GridItem, Spinner, Text, Button
} from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { FaUpload } from "react-icons/fa";
import FolderHeader from "./Header";
// [FIX] direct imports — lazy() + Suspense causes React #321 with Chakra v2 + React 19
import Folder from "./Folder";
import File from "./File";

const ViewManager = ({
  SelectedFolder,
  OnRefetch,
  Height,
  Props = {},
  OnChange,
  OnSelect,
  OnSubmitFolder,
  OnSubmitFile,
  texts = {} 
}) => {
  const {
    FolderData = { Folders: [], Files: [] },
    AllFolders = [], 
    IsFoldersLoading, 
  } = Props;

  const { Folders: subFolders, Files } = FolderData;
  const fileManagerTexts = texts?.fileManager || {};
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  const haveContent = useMemo(() => {
    return (subFolders && subFolders.length > 0) || (Files && Files.length > 0);
  }, [subFolders, Files]);


  const handleUploadClick = () => {
    OnChange({
      IsOpen: true,
      Tab: "UploadFile",
      ParentId: SelectedFolder
    });
  };


  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (SelectedFolder && !isDraggingOver) {
      setIsDraggingOver(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(false);
    
    if (!SelectedFolder) return;
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {

      OnChange({
        IsOpen: true,
        Tab: "UploadFile",
        ParentId: SelectedFolder,
        DroppedFiles: files 
      });

    }
  };

  return (
    <Box
      w={"100%"}
      h={Height}
      border="1px solid"
      borderRadius="md"
      px={3}
      sx={{
        bg: 'var(--fm-view-bg)',
        borderColor: 'var(--fm-view-border)',
        color: 'var(--fm-view-text)'
      }}
    >
      {/* Header  */}
      <Flex justify="space-between" align="center" mb={0}>
        <Box flex="1">
          <FolderHeader
            OnChange={OnChange}
            OnRefetch={OnRefetch}
            Selected={SelectedFolder}
            AllFolders={AllFolders}
            texts={texts}
          />
        </Box>
        
          <Button
            leftIcon={<FaUpload />}
            size="sm"
            variant="solid"
            onClick={handleUploadClick}
            sx={{
              bg: 'var(--upload-btn-bg)',
              color: 'var(--upload-btn-text)',
              _hover: { bg: 'var(--upload-btn-hover-bg)' },
              ml: 3,
              minWidth: "120px"
            }}
          >
            {fileManagerTexts.upload || "Upload"}
          </Button>
      </Flex>
      
      {/* */}
      <Box 
        borderTop="1px solid" 
        sx={{ borderColor: 'var(--fm-view-border)' }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {IsFoldersLoading ? (
          <Flex h="calc(100% - 70px)" align="center" justify="center">
            <Spinner 
              size="xl" 
              thickness="4px"
              sx={{ color: 'var(--Spinner)' }} 
            />
          </Flex>
        ) : (!SelectedFolder && haveContent) || (SelectedFolder && haveContent) ? (
          <Box mt={2}>
            <Grid 
              templateColumns={"repeat(12, 1fr)"} 
              gap={2}
              alignItems={"center"} 
              borderBottomWidth="1px" 
              pb={2} 
              mb={2}
              sx={{ borderColor: 'var(--fm-view-border)' }}
            >
              <GridItem colSpan={{ base: 12, md: 5 }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.name || "Name"}
                </Text>
              </GridItem>
              <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.size || "Size"}
                </Text>
              </GridItem>
              <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.lastModified || "Last Modified"}
                </Text>
              </GridItem>
              <GridItem colSpan={3} textAlign="end">
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.actions || "Actions"}
                </Text>
              </GridItem>
            </Grid>
            <Box 
              overflowY={"auto"} 
              h={`calc(${Height.md} - 9rem)`} 
              sx={{ 
                '&::-webkit-scrollbar': { 
                  width: '8px',
                  height: '8px'
                }, 
                '&::-webkit-scrollbar-track': { 
                  background: 'var(--fm-view-scrollbar-track)',
                  borderRadius: '10px'
                }, 
                '&::-webkit-scrollbar-thumb': { 
                  background: 'var(--fm-view-scrollbar-thumb)', 
                  borderRadius: '10px',
                  _hover: {
                    background: 'var(--fm-view-scrollbar-thumb-hover)'
                  }
                } 
              }}
            >
              {subFolders?.map(folder => (
                <Folder
                  key={folder.FolderId}
                  Item={folder}
                  OnChange={OnChange}
                  OnSelect={OnSelect}
                  OnSubmit={OnSubmitFolder}
                  texts={texts}
                />
              ))}
              {Files?.map(file => (
                <File
                  key={file.FileId}
                  Item={file}
                  OnChange={OnChange}
                  OnSubmit={OnSubmitFile}
                  texts={texts}
                />
              ))}
            </Box>
          </Box>
        ) : !haveContent && SelectedFolder ? (
       
          <Box
            h="calc(100% - 70px)"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            border={isDraggingOver ? "3px dashed" : "2px dashed"}
            borderRadius="xl"
            p={{ base: 6, md: 10 }}
            mx={{ base: 2, md: 5 }}
            textAlign="center"
            sx={{
              borderColor: isDraggingOver 
                ? 'var(--upload-dropzone-active-border)' 
                : 'var(--upload-dropzone-border)',
              bg: isDraggingOver 
                ? 'var(--upload-dropzone-active-bg)' 
                : 'var(--upload-dropzone-bg)',
              color: 'var(--fm-empty-text-color)',
              transition: 'all 0.3s ease',
              _hover: {
                borderColor: 'var(--upload-dropzone-hover-border)',
                bg: 'var(--upload-dropzone-hover-bg)',
                transform: 'translateY(-2px)'
              }
            }}
            cursor="pointer"
            onClick={handleUploadClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {/*  */}
            <Box 
              fontSize={{ base: "3.5rem", md: "4.5rem" }} 
              mb={4}
              sx={{ 
                color: isDraggingOver 
                  ? 'var(--upload-dropzone-active-icon)' 
                  : 'var(--upload-dropzone-icon)',
                transition: 'all 0.3s ease'
              }}
            >
              {isDraggingOver ? "⬆️" : "📁"}
            </Box>
            
            {/*  */}
            <Text 
              fontSize={{ base: "xl", md: "2xl" }} 
              fontWeight="bold" 
              mb={3}
            >
              {isDraggingOver 
                ? (fileManagerTexts.dropHere || "Drop files here...") 
                : (fileManagerTexts.folderIsEmpty || "This folder is empty")
              }
            </Text>
            
            {/*  */}
            <Text 
              fontSize={{ base: "sm", md: "md" }} 
              mb={6} 
              opacity={0.8}
              maxW="500px"
              lineHeight="1.6"
            >
              {isDraggingOver 
                ? (fileManagerTexts.releaseToUpload || "Release to upload files")
                : (fileManagerTexts.dragDropInstructions || "click the button below")
              }
            </Text>
            
            {/*   */}
            <Button
              leftIcon={<FaUpload />}
              size={{ base: "md", md: "lg" }}
              variant="solid"
              onClick={(e) => {
                e.stopPropagation(); 
                handleUploadClick();
              }}
              sx={{
                bg: 'var(--upload-btn-bg)',
                color: 'var(--upload-btn-text)',
                _hover: { 
                  bg: 'var(--upload-btn-hover-bg)',
                  transform: 'scale(1.05)'
                },
                transition: 'all 0.2s',
                px: 8,
                py: 6
              }}
            >
              {fileManagerTexts.uploadFilesHere || "Upload files here"}
            </Button>
            
            {/* */}
            <Text 
              fontSize="sm" 
              mt={6} 
              opacity={0.6}
              display={{ base: 'none', md: 'block' }}
            >
              {fileManagerTexts.supportedFormats || "Supports: Images (JPG, PNG, GIF), PDF, Documents (DOC, DOCX, TXT)"}
            </Text>
            
            {/* */}
            {isDraggingOver && (
              <Box
                position="absolute"
                top="10px"
                right="10px"
                bg="var(--upload-dropzone-active-bg)"
                color="var(--upload-dropzone-active-icon)"
                px={3}
                py={1}
                borderRadius="full"
                fontSize="sm"
                fontWeight="bold"
                border="1px solid"
                borderColor="var(--upload-dropzone-active-border)"
              >
                {fileManagerTexts.dragging || "Dragging..."}
              </Box>
            )}
          </Box>
        ) : (
          
          <Flex 
            h="calc(100% - 70px)" 
            align="center" 
            justify="center" 
            direction="column"
            gap={4}
            p={8}
            textAlign="center"
          >
            <Box fontSize="4rem" mb={4} sx={{ color: 'var(--fm-empty-text-color)', opacity: 0.7 }}>
              📂
            </Box>
            
            <Text fontSize="xl" fontWeight="bold" mb={2}>
              {fileManagerTexts.selectFolderToView || "Select a folder to view its contents"}
            </Text>
            
            <Text fontSize="md" opacity={0.7} maxW="400px">
              {fileManagerTexts.selectFolderInstructions || "Choose a folder from the sidebar to start managing your files"}
            </Text>
            
            {/*  */}
            <Box
              mt={6}
              p={4}
              borderRadius="lg"
              sx={{
                bg: 'var(--tips-bg)',
                border: '1px solid var(--tips-border)',
                maxWidth: '400px'
              }}
            >
              <Text fontSize="sm" fontWeight="bold" mb={2}>
                💡 {fileManagerTexts.tip || "Tip"}
              </Text>
              <Text fontSize="sm" opacity={0.8}>
                {fileManagerTexts.createFolderTip || "You can create a new folder by clicking the '+' icon in the sidebar"}
              </Text>
            </Box>
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default ViewManager;